export default function Footer() {
  return (
    <footer className="bg-[#111c29] border-t border-white/5 py-8">
      <div className="max-w-6xl mx-auto px-6 md:px-10 flex flex-col sm:flex-row items-center justify-between gap-4">
        <span className="text-sm font-bold tracking-widest text-white/30 uppercase">BLANO DOO</span>
        <span className="text-xs text-white/25">&copy; {new Date().getFullYear()} All rights reserved.</span>
      </div>
    </footer>
  );
}
